var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessThan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9593 12.7464L7.70928 8.99635L13.9593 5.24635C14.0414 5.19711 14.1118 5.13379 14.1667 5.06003C14.2216 4.98626 14.2598 4.90349 14.2792 4.81644C14.2985 4.72938 14.2986 4.63975 14.2795 4.55266C14.2603 4.46557 14.2223 4.38272 14.1676 4.30885C14.1129 4.23498 14.0425 4.17154 13.9606 4.12214C13.8786 4.07274 13.7867 4.03835 13.6899 4.02094C13.5932 4.00353 13.4936 4.00344 13.3968 4.02066C13.3001 4.03789 13.208 4.07211 13.1259 4.12135L6.04094 8.37235C5.92681 8.44085 5.83323 8.53364 5.76851 8.64249C5.70379 8.75134 5.66992 8.87289 5.66992 8.99635C5.66992 9.11981 5.70379 9.24136 5.76851 9.35022C5.83323 9.45907 5.92681 9.55186 6.04094 9.62035L13.1259 13.8714C13.208 13.9206 13.3001 13.9548 13.3968 13.972C13.4936 13.9893 13.5932 13.9892 13.6899 13.9718C13.7867 13.9544 13.8786 13.92 13.9606 13.8706C14.0425 13.8212 14.1129 13.7577 14.1676 13.6839C14.2223 13.61 14.2603 13.5271 14.2795 13.44C14.2986 13.353 14.2985 13.2633 14.2792 13.1763C14.2598 13.0892 14.2216 13.0064 14.1667 12.9327C14.1118 12.8589 14.0414 12.7956 13.9593 12.7464Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessThan);
export default __webpack_public_path__ + "static/media/less-than.1fdcb8bab34f09ef7e3a410b639c8618.svg";
export { ForwardRef as ReactComponent };